"use strict";

(function () {
    const theme = {
        // 16 hours = 16 * 60 = 960 minutes
        save: function (value, expiration_mins) {
            if ("localStorage" in window && window["localStorage"] !== null) {
                const record = {
                    value,
                    timestamp:
                        new Date().getTime() + expiration_mins * 60 * 1000,
                };
                localStorage.setItem("theme_color", JSON.stringify(record));
            }
        },

        color: function () {
            let color = "white"; // default

            // User has recently selected a theme
            if ("localStorage" in window && window["localStorage"] !== null) {
                const record = JSON.parse(localStorage.getItem("theme_color"));
                if (
                    record &&
                    record.value &&
                    record.timestamp &&
                    new Date().getTime() < record.timestamp
                ) {
                    color = record.value;
                }
            }

            return color;
        },

        change: function (color) {
            document.querySelector("html").className = document
                .querySelector("html")
                .className.replace(/\bis-color-(\S+)\b/g, "");
            document.querySelector("html").classList.add("is-color-" + color);
        },
    };

    // Initialize
    theme.change(theme.color());

    // Switch theme
    document.addEventListener("click", function (event) {
        const target = event.target;
        if (target.className === "js-color-option") {
            target.blur();
            theme.change(target.dataset.color);
            theme.save(target.dataset.color, 960);
        }
    });
})();
